import { Message } from '../../../types/models';
import { QwenChatMessage } from './types';

export const formatMessages = (messages: Message[]): QwenChatMessage[] => {
  console.log('Formatting messages:', messages);
  const formatted = messages.map((message) => ({
    role: message.role as 'system' | 'user' | 'assistant',
    content: message.content,
  }));
  console.log('Formatted messages:', formatted);
  return formatted;
};

export const formatStreamingContent = (chunk: string): string => {
  try {
    if (chunk === '[DONE]') return '';
    
    const data = JSON.parse(chunk.replace(/^data: /, ''));
    return data.choices[0]?.delta?.content || '';
  } catch (error) {
    console.error('Error parsing streaming chunk:', error);
    return '';
  }
};